import { isProAppPath } from '@percent/cause-dashboard/constants/goodstackPro'

export enum SignUpEventName {
  SEARCH_FOR_NONPROFIT = 'Search for non profit',
  SEARCH_RESULTS = 'Search results',
  CLAIM_NONPROFIT = 'Claim non profit click',
  SIGNUP_AND_CLAIM = 'Sign up and claim click',
  SIGNUP_PAGE_VISITED = 'Sign up page visited',
  SIGNUP_FORM_STARTED = 'Sign up form started',
  SIGNUP_PHONE_ENTERED = 'Sign up phone entered',
  SIGNUP_SUBMIT_BLOCKED = 'Sign up submit blocked',
  SIGNUP_SUBMIT_ATTEMPTED = 'Sign up submit attempted',
  SIGNUP_COMPLETED = 'Sign up completed',
  ORG_ALREADY_CLAIMED_ERROR = 'Org already claimed error'
}

export enum CaptchaEventName {
  VERIFICATION_STARTED = 'Captcha verification started',
  VERIFICATION_SUCCEEDED = 'Captcha verification succeeded',
  VERIFICATION_FAILED = 'Captcha verification failed',
  VERIFICATION_SLOW = 'Captcha verification slow',
  VERIFICATION_SKIPPED = 'Captcha verification skipped'
}

export enum DonationFormEventName {
  DONATION_FORM_PAGE_VIEWED = 'Donation form page viewed',
  APPLY_FOR_DONATION_FORM_ACCESS_CLICKED = 'Apply for donation form access clicked',
  UPDATE_PROFILE_FOR_DONATION_FORM_ACCESS_CLICKED = 'Update profile for donation form access clicked',
  LOAD_GOODSTACK_LIBRARY = 'Load the Goodstack library',
  ADD_DONATE_BUTTON = 'Add the donate button',
  SHARE_LINK_BUTTON = 'Share link button clicked'
}

export enum SideMenuEventName {
  SIDE_MENU_ITEM_CLICKED = 'Side menu item clicked'
}

export enum SurveyEventName {
  DISCOUNT_REDEMPTION_SURVEY_VIEWED = 'Discount redemption survey viewed',
  DISCOUNT_REDEMPTION_SURVEY_SUBMITTED = 'Discount redemption survey submitted'
}

/**
 * Stable ids for side menu items for funnel analysis (e.g. CP → Goodstack Pro).
 * Paths must match RoutePath in app/routes/Routes.tsx (cannot import there: circular dependency
 * via Routes → ClaimPage → ClaimSearchResults → this file).
 */
const PATH_TO_MENU_ITEM_ID: Record<string, string> = {
  '/home': 'home',
  '/profile': 'profile',
  '/donations': 'donations',
  '/donation-form': 'donation_form',
  '/payouts': 'payouts',
  '/product-offers': 'product_offers',
  '/savings-calculator': 'savings_calculator',
  '/my-discounts': 'my_discounts',
  '/ai': 'goodstack_pro',
  '/pro/login': 'goodstack_pro',
  '/volunteering': 'volunteering',
  '/grants': 'grants'
}

/**
 * Resolves a stable menu_item_id from an item href for analytics (path only; query string ignored).
 */
export function getMenuItemId(href: string): string {
  const path = href.split('?')[0] ?? ''
  if (PATH_TO_MENU_ITEM_ID[path]) return PATH_TO_MENU_ITEM_ID[path]
  if (path.startsWith('/ai') || isProAppPath(path)) return 'goodstack_pro'
  return path.slice(1).replace(/\//g, '_') || 'other'
}
